import Vue from "vue"
import Router from "vue-router"
import store from "./store"
import $i18n from "./i18n"

import {
  Bikentapedia,
  Declaration,
  EnquiryChat,
  Home,
  IncidenceDetail,
  Login,
  NotificationsPage,
  ParcelDetail,
  Parcels,
  ParcelsMap,
  PasswordNew,
  PasswordReset,
} from "./views"

Vue.use(Router)

export const MENU_ROUTES = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      title: () => $i18n.t("page.title.home"),
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters.isAuthenticated) {
        return next({ name: "login" })
      }

      return next()
    },
  },
  {
    path: "/parcels",
    name: "parcels",
    component: Parcels,
    meta: {
      title: () => $i18n.t("page.title.parcels"),
    },
  },
  {
    path: "/mapa",
    name: "mapa",
    component: ParcelsMap,
    meta: {
      title: () => $i18n.t("page.title.map"),
    },
  },
  {
    path: "/bikentapedia",
    name: "bikentapedia",
    component: Bikentapedia,
    meta: {
      title: () => $i18n.t("page.title.bikentapedia"),
    },
  },
  {
    path: "/notifications",
    name: "notifications",
    component: NotificationsPage,
    meta: {
      title: () => $i18n.t("page.title.notifications"),
    },
  },
]

const router = new Router({
  linkActiveClass: "is-active",
  routes: [
    ...MENU_ROUTES,
    {
      path: "/declaration/:type",
      name: "declaration",
      component: Declaration,
      meta: {
        title: () => $i18n.t("page.title.declaration"),
      },
    },
    {
      path: "/parcels/:id",
      name: "parcel-detail",
      component: ParcelDetail,
    },
    {
      path: "/incidences/:id/open_enquiry",
      name: "incidence-open-enquiry",
      component: IncidenceDetail,
    },
    {
      path: "/enquiries/:enquiryId",
      name: "enquiry-chat",
      component: EnquiryChat,
    },
    {
      path: "/n/",
      name: "short-notifications",
      component: NotificationsPage,
    },
    {
      path: "/n/:id",
      name: "short-notifications-legacy",
      component: NotificationsPage,
    },
    {
      path: "/np/:token",
      name: "new-password-set",
      component: PasswordNew,
      meta: { anonymous: true },
    },
    {
      path: "/password-reset",
      name: "password-reset",
      component: PasswordReset,
      meta: { anonymous: true },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        title: () => $i18n.t("page.title.login"),
        anonymous: true,
      },
      beforeEnter: (to, from, next) => {
        if (store.getters.isAuthenticated) {
          return next({ name: "home" })
        }

        return next()
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (!store.state.loaded) {
    store.dispatch("load")
  }

  // Redirect to login if is not authorized
  if (to.matched.some(record => !record.meta.anonymous)) {
    if (!store || !store.getters.token) {
      next = { path: to["path"] }
      store.dispatch("logOut", next)
      return
    }
  }

  if (to.meta.title) {
    document.title = `${to.meta.title(to)} — Bikenta`
  }

  return next()
})

export default router
